import { PublicClientApplication } from '@azure/msal-browser';
import type { IHostConfig } from '../config';

/**
 * The host's own Entra SPA client (D3, RPF-177), configured only from config.json.
 * No MSAL logger: it would print PII and token metadata to the console.
 */
export function createMsalInstance(config: IHostConfig): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.msalClientId,
      authority: `https://login.microsoftonline.com/${config.msalTenantId}`,
      redirectUri: config.msalRedirectUri ?? window.location.origin,
      postLogoutRedirectUri: '/',
    },
    cache: { cacheLocation: 'localStorage' },
  });
}
